import { Component, inject } from '@angular/core';
import { AvHeaderComponent } from '../../Shared/Components/av-header/av-header.component';
import { NavigationService } from '../../Navigation/Services/navigation.service';
import { COMMON_IMPORTS } from '../../Shared/common-imports';
import { AvFooterComponent } from '../../Shared/Components/av-footer/av-footer.component';
import { NavigationMenuComponent } from '../Components/Partials/navigation-menu/navigation-menu.component';

@Component({
  selector: 'av-settings',
  standalone: true,
  imports: [COMMON_IMPORTS, AvHeaderComponent, AvFooterComponent, NavigationMenuComponent],
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent {
  private navigationService = inject(NavigationService);

  ngOnInit(): void {
    this.navigationService.setActiveItem({
      label: 'settings',
      icon: 'settings',
      route: '/settings',
    });
  }
}